import { render, staticRenderFns } from "./SetarSetores.vue?vue&type=template&id=1dfee492&scoped=true&"
import script from "./SetarSetores.vue?vue&type=script&lang=js&"
export * from "./SetarSetores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfee492",
  null
  
)

export default component.exports